import { baseQuerySetup,transformResponse,onQueryStarted, onCacheEntryAdded } from 'config/index';
import { createApi } from '@reduxjs/toolkit/query/react';
import { setNavLoader } from './App.service';
import { getApiPrefixFromUserType } from 'utils/roles';

// realtor invitations
let realtorReducer = 'realtorReducer';
let realtorTag = 'realtorTag';

export const realtorApi = createApi({
    reducerPath: realtorReducer,
    baseQuery: baseQuerySetup,
    tagTypes: [realtorTag],
    endpoints: (builder) => ({
        getAllRealtors: builder.query({
            query: ({ query }) => {
                return { url: '/realtors' + query, method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse
        }),
        getBulkInvitedRealtors: builder.query({
            query: (USERTYPE) => {
                let prefix = getApiPrefixFromUserType(USERTYPE);

                return { url: '/pre-added' + prefix , method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse
        }),
        BulkInviteRealtor: builder.mutation({
            query: ({ body , USERTYPE }) => {
                const prefix = getApiPrefixFromUserType(USERTYPE);
                return { url: `pre-added${prefix}/bulk-invite` , method: 'POST', body };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse
        }),
        ResendBulkInvite: builder.mutation({
            query: ({ invitationId , USERTYPE }) => {
                const prefix = getApiPrefixFromUserType(USERTYPE);
                return { url: `pre-added${prefix}/reinvite/${invitationId}` , method: 'PUT' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse
        }),
        GetBulkInviteDetails: builder.query({
            query: ({ invitationId , USERTYPE }) => {
                const prefix = getApiPrefixFromUserType(USERTYPE);
                return { url: `pre-added${prefix}/${invitationId}` , method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse
        }),

        getRaltorDetails: builder.query({
            query: (id) => {
                return { url: '/realtors/' + id , method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse,
            invalidatesTags: [realtorTag]
        }),
        UpdateRealtor: builder.mutation({
            query: ({ id , body }) => {
                return { url: '/realtors/' + id , method: 'PUT', body };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse,
            invalidatesTags: [realtorTag]
        }),
        UpdateRealtorCompany: builder.mutation({
            query: ({ id , body }) => {
                return { url: '/realtors/company/' + id , method: 'PUT', body };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse,
            invalidatesTags: [realtorTag]
        }),
        SuspectToggleRaltorDetails: builder.mutation({
            query: ({ id , body }) => {
                return { url: '/realtors/' + id + '/suspend-unsuspend', method: 'PUT', body };
            },
            async onQueryStarted({ query, id }, { dispatch , queryFulfilled }) {
                try {
                    dispatch(setNavLoader(true));
                    await queryFulfilled;
                    dispatch(realtorApi.util.updateQueryData('getAllRealtors',{ query } ,(draft) => {
                        let record = draft.find((row)=> row._id === id);

                        record.isSuspendedByAdmin = !record?.isSuspendedByAdmin;
                    }));
                    dispatch(setNavLoader(false));
                } catch (error) {
                    dispatch(setNavLoader(false));
                }
            },
            onCacheEntryAdded,
            transformResponse,
            invalidatesTags: [realtorTag]
        })
    })
});
export const { useInviteRealtorMutation, useGetBulkInviteDetailsQuery, useResendBulkInviteMutation , useGetBulkInvitedRealtorsQuery, useBulkInviteRealtorMutation, useLazyGetAllRealtorsQuery,useGetAllRealtorsQuery , useGetRaltorDetailsQuery, useSuspectToggleRaltorDetailsMutation, useUpdateRealtorMutation, useUpdateRealtorCompanyMutation } = realtorApi;
